// Helper to rewrite inline template images (src="images/...") to presigned URLs.
// - html: string HTML content
// - buildKey: function (filename: string) => doc_name string for getContentUrl
// - options.getContentUrlFn: optional function to fetch a presigned URL; falls back to global getContentUrl if available.
export async function rewriteTemplateImagesToPresigned(html, buildKey, options = {}) {
	try {
		if (typeof html !== 'string' || typeof buildKey !== 'function') return html;

		const getContentUrlFn =
			typeof options.getContentUrlFn === 'function' ? options.getContentUrlFn : typeof getContentUrl === 'function' ? getContentUrl : null;

		if (!getContentUrlFn) return html;

		const imageSrcRegex = /src="images\/([^"]+)"/g;
		const imageFiles = new Set();
		let match;
		while ((match = imageSrcRegex.exec(html)) !== null) {
			if (match[1]) imageFiles.add(match[1]);
		}

		if (!imageFiles.size) return html;

		const presignedMap = {};
		await Promise.all(
			Array.from(imageFiles).map(async (file) => {
				try {
					const key = buildKey(file);
					if (!key) return;
					presignedMap[file] = await getContentUrlFn(key);
				} catch (err) {
					console.error('Error getting presigned URL for template image', file, err);
				}
			})
		);

		const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		imageFiles.forEach((file) => {
			const url = presignedMap[file];
			if (!url) return;
			const pattern = new RegExp(`src="images/${escapeRegex(file)}"`, 'g');
			html = html.replace(pattern, `src="${url}"`);
		});

		return html;
	} catch (err) {
		console.error('Failed to rewrite template image URLs to presigned URLs:', err);
		return html;
	}
}
